import React from 'react';

import './SimpleLoginPage.css';
import logo from 'static/img/logo-white.svg';

const SimpleLoginPage = () => {
    const loginWithProvider = (providerType) => {
        const urlParams = new URLSearchParams(window.location.search);
        const postLoginRedirectUri = urlParams.get('redirect_uri');
        window.location = `${process.env.REACT_APP_LOGIN_REDIRECT_URL}?provider=${providerType}&redirect_uri=${ encodeURIComponent(postLoginRedirectUri)}`;
    }

    return (
        <div className="SimpleLogin">
            <img className="SimpleLogin-logo" src={logo} alt="Burn for Money" />
            <p className="SimpleLogin-text">
            Hello!<br/>
            Use your company account<br/>
            to login in to Burn for Money dashboard
            </p>
            <button onClick={() => loginWithProvider("aad")} className="Button SimpleLogin-button">Log in</button><br/>
        </div>
    );
}

export default SimpleLoginPage;



// WEBPACK FOOTER //
// ./src/components/Authentication/SimpleLoginPage.js